import React from 'react';

import Form from '@rjsf/mui';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import { useSnackbar } from 'notistack';
import fileDownload from 'react-file-download';

import { Box, Button } from '@mui/material';

import { downloadCarHireBookingsReport } from '~/services/ReportingService';
import { formatDateISO, startOfMonth, subMonths } from '~/services/TimeService';

const formSchema: RJSFSchema = {
  description: 'Please enter your dates to export Car Hire bookings report',
  type: 'object',
  properties: {
    startAt: {
      title: 'Select Start Date',
      type: 'string',
      format: 'date',
    },
    endAt: {
      title: 'Select End Date',
      type: 'string',
      format: 'date',
    },
    fileFormat: {
      type: 'string',
      title: 'File Format',
      enum: ['csv', 'email'],
    },
  },
};

const formData = {
  startAt: formatDateISO(startOfMonth(subMonths(1))),
  endAt: formatDateISO(startOfMonth()),
  fileFormat: 'email',
};

const uiSchema = {
  startAt: {
    'ui:widget': 'date',
  },
  endAt: {
    'ui:widget': 'date',
  },
  fileFormat: {
    'ui:widget': 'radio',
  },
};

export default function ExportCarHireBookingsForm() {
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = (event) => {
    const { startAt, endAt, fileFormat } = event.formData;

    const data = downloadCarHireBookingsReport({ startAt, endAt, fileFormat });

    data
      .then((text) => {
        if (fileFormat !== 'email') {
          const fileName = `car_hire_bookings_report_${startAt}_${endAt}.${fileFormat}`;
          fileDownload(text, fileName);
        } else {
          enqueueSnackbar(`Your report is queued for delivery and will be emailed shortly.`, { variant: 'success' });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, { variant: 'error' });
      });
  };

  return (
    <Box>
      <Form
        schema={formSchema}
        uiSchema={uiSchema}
        formData={formData}
        onSubmit={handleSubmit}
        validator={validator}
        showErrorList={false}
      >
        <Button type="submit" variant="contained">
          Download/Email Car Hire Bookings Report
        </Button>
      </Form>
    </Box>
  );
}
